/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import styles from './CodeInput.module.scss';
import { Input } from '../Input/Input';

interface CodeInputI {
  size?: number;
  error?: boolean;
  onChange?: (code: string) => void;
}

export const CodeInput = ({
  size = 4,
  onChange = () => {},
  error = false,
}: CodeInputI) => {
  const ref = useRef<HTMLDivElement>(null);
  const [inputs, setInputs] = useState<number[]>([]);
  const [actualInput, setActualInput] = useState(0);
  const [finalValue, setFinalValue] = useState<string>('');

  useEffect(() => {
    const elements: number[] = [];

    for (let i = 0; i < size; i += 1) {
      elements.push(i);
    }

    setInputs(elements);
  }, []);

  const renderInputs = () => {
    return inputs.map((input, index) => (
      <Input
        key={input}
        classname={cn(styles.input, error && styles.error)}
        placeholder="0"
        onKeyDownCapture={(event) => {
          if (event.key === 'Tab') {
            event.preventDefault();
            return;
          }

          if (event.key === 'Backspace') {
            event.currentTarget.value = '';
            if (actualInput >= 0) {
              setFinalValue((s) => s.slice(0, actualInput));
              if (actualInput > 0) {
                (
                  ref.current.children[actualInput - 1]
                    ?.children[0] as HTMLInputElement
                ).focus();
                setActualInput(actualInput - 1);
              }
            }
            event.preventDefault();
            return;
          }

          if (
            /[-+]/g.test(event.key) ||
            /^[eE.]$/g.test(event.key) ||
            event.currentTarget.value.length > 0
          ) {
            event.preventDefault();
          }

          if (
            event.currentTarget.value.length === 1 &&
            actualInput < inputs.length - 1
          ) {
            (
              ref.current.children[actualInput + 1]
                ?.children[0] as HTMLInputElement
            ).focus();
            (
              ref.current.children[actualInput + 1]
                ?.children[0] as HTMLInputElement
            ).value = event.key;
            setActualInput(actualInput + 1);
            setFinalValue((s) => s + event.key);
            event.preventDefault();
            return;
          }

          if (/^(?:[0-9]\d*|\d*\.\d+)$/.test(event.key)) {
            if (
              actualInput < inputs.length &&
              finalValue.length < inputs.length
            ) {
              if (actualInput < inputs.length - 1) {
                (
                  ref.current.children[actualInput]
                    ?.children[0] as HTMLInputElement
                ).value = event.key;
                (
                  ref.current.children[actualInput + 1]
                    ?.children[0] as HTMLInputElement
                ).focus();
                setActualInput(actualInput + 1);
                event.preventDefault();
              }
              setFinalValue((s) => s + event.key);
            }
          }
        }}
        type="number"
        onKeyDown={(event) => {}}
        onChange={(event) => {}}
      />
    ));
  };

  useEffect(() => {
    onChange?.(finalValue);
  }, [finalValue]);

  return (
    <div
      ref={ref}
      onClickCapture={(event) => {
        let shouldBreak = false;
        inputs.forEach((input, index) => {
          if (shouldBreak) return;

          const element = (ref.current.children[index] as HTMLDivElement)
            ?.children[0] as HTMLInputElement;
          const { value } = element;

          if (value === '' || index === inputs.length - 1) {
            element.type = 'text';
            element.setSelectionRange(value.length, value.length);
            element.type = 'number';
            element.focus();
            setActualInput(index);
            shouldBreak = true;
          }
        });
      }}
      className={styles.root}
    >
      {renderInputs()}
    </div>
  );
};
